import { defineStore } from 'pinia'

import state from './state.js'
import getters from './getters.js'
import actions from './actions.js'

const useWidgetsStore = defineStore('widgets', {
  state,
  getters,
  actions
})

export default useWidgetsStore
